//External
import React, { useState, useEffect } from "react";
import copy from "copy-to-clipboard";
import Modal from "react-bootstrap/Modal";
import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  PinterestIcon,
  RedditIcon,
  TwitterIcon,
  WhatsappIcon,
  FacebookMessengerShareButton,
} from "react-share";
import SuccessPopup from "../../components/modals/success-popup";
import { FB_ID } from "../../config";
import * as deviceObj from "react-device-detect";
import { getFadeFlag } from "utils";

/*******************
@Purpose : used for social medial share
@Parameter : { Data }
@Author : INIC
******************/
function SocialShareModel({ data, flag, show, handleClose }) {
  const [url, setUrl] = useState();
  const [addOnClass, setAddOnClass] = useState("hide");
  const [isDesktop, setIsDesktop] = useState(true);

  /*******************
@Purpose : React Hook used for href path
@Parameter : {}
@Author : INIC
******************/
  useEffect(() => {
    const host = window.location.href;
    setUrl(host);
    if (deviceObj.isMobile || deviceObj.isTablet) {
      setIsDesktop(false);
    }
  }, []);

  /*******************
@Purpose : used for copy text and showing alert
@Parameter : {}
@Author : INIC
******************/
  function copyHandler() {
    copy(url);
    setAddOnClass("show");
    setTimeout(() => {
      setAddOnClass("hide");
    }, 1500);
  }

  /*******************
@Purpose : used for sharing image
@Parameter : {}
@Author : INIC
******************/
  function shareImage() {
    return data?.vehicle
      ? data?.vehicle?.all_images?.[0]?.image?.main
      : data?.featured_image;
  }

  const getTitle = () => {
    if (flag == "vehicle") {
      return data?.vehicle?.name_with_brand;
    } else {
      return data?.title;
    }
  };

  const fbMessageOnClickHandler = (url) => {
    const finalUrl =
      "fb-messenger://share?link=" +
      encodeURIComponent(url) +
      "&app_id=" +
      encodeURIComponent(FB_ID);
    window.location.href = finalUrl;
  };

  /*******************
@Purpose : used for details share on whatsApp 
@Parameter : {url}
@Author : INIC
******************/
  const handleWhatsAppShare = (url1) => {
    const title = getTitle();
    const finalData = title + " " + url1;
    const url = "whatsapp://send?text=" + finalData;
    window.location.href = url;
  };

  /*******************
@purpose : Render HTML/ React Components
@Author : INIC
******************/
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className="sharing-model"
        centered
      >
        <Modal.Header closeButton className="">
          <h4 className="mb-0">
            {flag == "vehicle"
              ? "Share this car with friends and family"
              : "Share this blog with friends and family"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          {flag == "vehicle" && (
            <div className="d-flex align-items-center car-detail-box mb-3 mb-sm-4">
              <div className="car-image">
                <img src={shareImage()} alt={data?.vehicle?.alt} />
              </div>
              <p className="font-18 mb-0">{data?.vehicle?.name_with_brand}</p>
            </div>
          )}

          <ul className="list-unstyled d-flex flex-wrap sharing-list">
            <li>
              <div
                className="d-flex align-items-center copy-link cursor-pointer"
                onClick={copyHandler}
              >
                <span className="icon icon-copy"></span>
                <span className=" ml-2 ml-sm-3">Copy link</span>
              </div>
            </li>
            <li>
              <EmailShareButton
                url={url}
                subject={getTitle()}
                body={getTitle()}
                separator=" - "
              >
                <EmailIcon size={30} />
                <span>Email</span>
              </EmailShareButton>
            </li>
            {getFadeFlag() ? (
              <li>
                <button
                  aria-label="whatsapp"
                  class="react-share__ShareButton"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: "0px",
                    font: "inherit",
                    color: "inherit",
                    cursor: "pointer",
                  }}
                  onClick={() => handleWhatsAppShare(url)}
                >
                  <svg viewBox="0 0 64 64" width="30" height="30">
                    <rect
                      width="64"
                      height="64"
                      rx="0"
                      ry="0"
                      fill="#25D366"
                    ></rect>
                    <path
                      d="m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
                      fill="white"
                    ></path>
                  </svg>
                  <span>WhatsApp</span>
                </button>
              </li>
            ) : (
              <li>
                <WhatsappShareButton title={getTitle()} url={url}>
                  <WhatsappIcon size={30} />
                  <span>WhatsApp</span>
                </WhatsappShareButton>
              </li>
            )}
            <li>
              <FacebookShareButton
                title={getTitle()}
                url={url}
                quote={getTitle()}
                description={getTitle()}
              >
                <FacebookIcon size={30} />
                <span>Facebook</span>
              </FacebookShareButton>
            </li>
            {isDesktop ? (
              <li>
                <FacebookMessengerShareButton
                  appId={FB_ID}
                  title={getTitle()}
                  url={url}
                  quote={getTitle()}
                >
                  <FacebookMessengerIcon size={30} />
                  <span>Messenger</span>
                </FacebookMessengerShareButton>
              </li>
            ) : (
              <li>
                <button
                  className="react-share__ShareButton"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: "0",
                    font: "inherit",
                    color: "inherit",
                    cursor: "pointer",
                  }}
                  onClick={() => fbMessageOnClickHandler(url)}
                >
                  <FacebookMessengerIcon size={30} />
                  <span>Messenger</span>
                </button>
              </li>
            )}
            <li>
              <TwitterShareButton title={getTitle()} url={url}>
                <TwitterIcon size={30} />
                <span>Twitter</span>
              </TwitterShareButton>
            </li>
            <li>
              <PinterestShareButton
                title={getTitle()}
                url={url}
                media={shareImage()}
              >
                <PinterestIcon size={30} />
                <span>Pinterest</span>
              </PinterestShareButton>
            </li>
            <li>
              <RedditShareButton
                title={getTitle()}
                url={url}
                media={shareImage()}
              >
                <RedditIcon size={30} />
                <span>Reddit</span>
              </RedditShareButton>
            </li>
          </ul>
        </Modal.Body>
      </Modal>
      <SuccessPopup addOnClass={addOnClass} message="Link copied" />
    </>
  );
}

export default SocialShareModel;
